// extracted by mini-css-extract-plugin
export default {"wrap":"MenuPage_wrap__7rmF4","menuBlock":"MenuPage_menuBlock__sIYun","outletBlock":"MenuPage_outletBlock__ZDeJB"};